import { PageLayout } from '@/layouts/page-layout'
import { Button } from '@material-tailwind/react'
import { Form, Formik } from 'formik'
import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigation, useSubmit } from 'react-router-dom'
import {
  CommercialInformationForm,
  LegalInformationForm,
  SafetyInformationForm,
  LegalRepresentativeForm,
  MainUserForm,
  validationSchema
} from './forms'
import { useAuthorization } from '@/hooks'
import { list } from '@/router/utils'
import { normalizePhone } from '@/utils'

export const CompanyCreate = () => {
  const submit = useSubmit()
  const { state } = useNavigation()
  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })
  const initialValues = useMemo(() => {
    return {
      document_number: '',
      name: '',
      activity: '',
      service_area_ids: [],
      email: '',
      phone: '',
      status: '',
      trade_name: '',
      business_line: '',
      accredited: '',
      control_type: '',
      other_contacts: '',
      legal_representative_attributes: {
        full_name: '',
        document_number: '',
        email: null,
        phone: null
      },
      user_attributes: {
        first_name: '',
        last_name: '',
        email: '',
        document_number: '',
        has_local_document_number: true,
        phone: ''
      },
      size: 'xs',

      // reemplazo correcto
      company_service_types: [],
      safety_information: null,
    }
  }, [])

  const { t } = useTranslation()

  // handlers

  const transformSubmitData = (values) => {
    const { company_service_types, ...rest } = values
    const userAttributes = rest.user_attributes || {}
    const normalizedUserAttributes = {
      ...userAttributes,
      phone: normalizePhone(userAttributes.phone),
      document_number: userAttributes.document_number?.trim() ? userAttributes.document_number : null
    }
    const normalizedSafetyInformation = rest.safety_information
      ? {
          ...rest.safety_information,
          safety_manager: {
            ...rest.safety_information?.safety_manager,
            phone: normalizePhone(rest.safety_information?.safety_manager?.phone)
          }
        }
      : rest.safety_information

    return {
      ...rest,
      phone: normalizePhone(rest.phone),
      legal_representative_attributes: {
        ...rest.legal_representative_attributes,
        phone: normalizePhone(rest.legal_representative_attributes?.phone)
      },
      safety_information: normalizedSafetyInformation,
      user_attributes: normalizedUserAttributes,
      company_service_types_attributes: company_service_types?.map((item) => ({
        account_service_type_id: item.account_service_type_id
      }))
    }
  }

  const onSubmit = (params) => {
    const transformed = transformSubmitData(params)
    submit(transformed, { method: 'post', encType: 'application/json' })
  }

  useEffect(() => {
    hasAccess('company#create')
  }, [])

  return (
    <PageLayout
      title={t('actions.create.with', {
        what: `${t('company.one').toLowerCase()}`
      })}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {() => (
          <Form>
            <LegalInformationForm />
            <SafetyInformationForm />
            <LegalRepresentativeForm />
            <MainUserForm />
            <CommercialInformationForm />

            <div className='flex justify-end gap-3 mt-10'>
              <Link to={list('companies')}>
                <Button variant='text' type='submit'>
                  {t('actions.cancel')}
                </Button>
              </Link>
              <Button loading={state === 'submitting'} type='submit'>{t('actions.create.one')}</Button>
            </div>
          </Form>
        )}
      </Formik>
    </PageLayout>
  )
}
